import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { endPoints } from "../../constant/Environment";
import { getAllData } from "../../Utility/API";
import Loader from "../../components/Loader";
import Modal from "react-bootstrap/Modal";
import { BsCart3 } from "react-icons/bs";
import { Link } from "react-router-dom";
import moment from "moment";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";

import { useSelector } from "react-redux";

function OfferList(props) {
  const state = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);
  const [promoList, setPromoList] = useState([]);
  const [showPromoImage, setPromoImage] = useState("");
  const [leagueId, setSelectedLeagueId] = useState("");
  const [league, setLeague] = useState("");

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [popupPromotions, setPopupPromotions] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setShow(true);
    setPopupPromotions(item);
  };

  useEffect(() => {
    getPromotionList();
  }, []);

  const dispatch = useDispatch();

  const getPromotionList = async (list) => {
    const filteredRows = props?.data?.filter(
      (item) => item.isfeatured == 1  && item.isactive == 1
    );
    if (filteredRows?.length > 0) {
      setPromoImage(filteredRows[0]);
    }
    setPromoList(props?.data || []);
  };
console.log('promoList',promoList)
  return (
    <>
      {/* <h1>offer page</h1> */}
      {
        promoList.map((item)=>{
          if(item.isactive == 1 && item.promo_message){
            return(
              <div className="highlighted-offer">
              <strong>
                {item.promo_message}
              </strong>
            </div>
            )
          }else {
            return null;
          }
        
        })
      }

      <Row className="g-2 promotion-img" style={{ marginLeft: "10px" }}>
        {showPromoImage && (
          <Col md={12}>
            <Link to={""} onClick={() => handleShow(showPromoImage)}>
              <img
                src={`${endPoints.apiBaseUrl}${showPromoImage.creative}`}
                alt={"Featured Image"}
                height="352px"
                style={{ width: "100%" }}
              />
            </Link>
          </Col>
        )}
        {isLoading && <Loader spinner={false} visible={isLoading} />}

        {promoList.map((item, ind) => {
          if (item.isfeatured == 0 && item.isactive == 1 && item.creative) {
            return (
              <Col md={4} xs="6">
                <Link to={""} onClick={() => handleShow(item)}>
                  <img
                    src={`${endPoints.apiBaseUrl}${item.creative}`}
                    alt={item.promo_name}
                  />
                </Link>
              </Col>
            );
          } else {
            return null;
          }
        })}

        {/* <Link className="nav-button-custom" to="/generate-code">Generate Code</Link> */}
      </Row>
      <Modal
        className="promotion_modal"
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h2>{popupPromotions.promo_name}</h2>
            <div className="wishlist row">
              <div className="col-4">
                <img
                  src={
                    popupPromotions.thumb_url
                      ? `${endPoints.apiBaseUrl}${popupPromotions.thumb_url}`
                      : `${endPoints.apiBaseUrl}${popupPromotions.creative}`
                  }
                  alt="logo1"
                  style={{ width: "100%" }}
                />
              </div>
              <div className="col-8">
                <div className="heading-popup-label">
                  {popupPromotions.promo_copy}
                </div>
                <div className="promotion_modal_p">
                  <p>
                    {" "}
                    Valid until{" "}
                    {moment
                      .utc(popupPromotions.enddate)
                      .format("h:mm A [EST], MMM D, YYYY")}
                  </p>
                </div>
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                className="join-btn-text loginbtn"
                style={{ background: "#0D3862", width: "50%" }}
                onClick={() => {
                  setShow(false);
                  navigate("/");

                  dispatch({
                    type: Actions.PROMO_PAGE,
                    data: false,
                  });
                }}
              >
                Okey
              </Button>
            </div>

            <div className="voucher-bottom">
              <p>{popupPromotions.terms_condition}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default OfferList;
